import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { Box, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const columns = [
  { id: 'login', label: 'Login' },
  { id: 'accessCode', label: 'Password' },
  { id: 'email', label: 'Email' },
  { id: 'company', label: 'Company' },
  { id: 'role_name', label: 'User Level' },
  { id: 'controller_name', label: 'Controller' },
  { id: 'createdDateTime', label: 'Valid From' },
  { id: 'expiredDateTime', label: 'Valid Till' },
  { id: 'actions', label: 'Actions'}
];

export default function AccessCodeTable({handleShare,handleCopy,rowsPerPage,page,handleChangePage,handleChangeRowsPerPage,accessCode}) {

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {accessCode?.data?.length > 0 ? accessCode?.data.map((row,i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                            ? column.format(value) 
                            : column.id === 'createdDateTime' ? dayjs(row.createdDateTime).startOf("day").format("YYYY-MM-DD HH:mm:ss") : column.id === 'expiredDateTime' ? dayjs(row.expiredDateTime).endOf("day").format("YYYY-MM-DD HH:mm:ss") 
                            : column.id === 'actions' ? 
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <IconButton onClick={(e)=> handleCopy(row.accessCode,row.login)} >
                                  <ContentCopyIcon sx={{ color:'black' }}/>
                              </IconButton>
                              <IconButton onClick={(e)=> handleShare(row.accessCode,row.login)} >
                                  <ShareIcon sx={{ color:'black' }} />
                              </IconButton>
                            </Box>
                            : value  
                            }
                        </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      {accessCode?.total > 0 ?
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={accessCode?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} />
        : <></>}
    </Paper>  
  );
}

